// extracted by mini-css-extract-plugin
export default {"showMore_text":"styles_showMore_text__y203J"};